import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { AnimatedLine } from "../animated-line";

import { AlertsSection } from "./alerts-section";
import { MetricsSection } from "./metrics-section";
import { RecommendationsSection } from "./recommendations-section";
import { LimitsBanner } from "app/pages/digital-marketing/monitor-and-protect/shared/components/limits/limits-banner";

export const NoCampaignsView = () => {
    return (
        <Stack
            alignItems="center"
            width="800px"
            margin="0 auto 24px"
            paddingY="32px"
        >
            <LimitsBanner />

            <Flex
                justifyContent="center"
                padding="32px 0 0 0"
                width="min-content"
                position="relative"
                margin="auto"
            >
                <AnimatedLine showAnimation={true} />
                <MetricsSection />
                <AlertsSection />
                <RecommendationsSection />
            </Flex>
        </Stack>
    );
};
